import React from "react";

export default function PrivateRoute({ children }) {
  // Authentication bypass: always render children for easier development
  return children;
}
